import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const VideoPlayer = ({ fileId }) => {
  const loading = useSelector((state) => state.analysisReports.screenshotsLoading);
  const videoResponse = useSelector((state) => state.analysisReports.screenshots);

  return (
    <div style={{ display: "flex" }}>
      {!loading ? (
        videoResponse && videoResponse.length ? (
          <video controls width="100%" height="278px">
            <source src={`data:video/mp4;base64,${videoResponse[0]}`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <video controls width="100%" height="278px">
            <source type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      ) : (
        <p>Loading video...</p>
      )}
    </div>
  );
};

export default VideoPlayer;
